module.exports = __webpack_public_path__ + "static/media/FR nouveau.95660e9d.svg";